module.exports = __webpack_public_path__ + "img/career-hero-2.935ce292.svg";